"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BodyOption = void 0;

var _react = _interopRequireDefault(require("react"));

var _PopularCountryOption = require("./PopularCountryOption");

var _AllCountryOption = require("./AllCountryOption");

var _Template = require("./Template");

var _PopularDirectionOptions = require("./PopularDirectionOptions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BodyOption = function BodyOption(data) {
  switch (data.groupName) {
    case 'countries':
    case 'popularCountries':
      return /*#__PURE__*/_react["default"].createElement(_PopularCountryOption.PopularCountryOption, data);

    case 'popularDirections':
      return /*#__PURE__*/_react["default"].createElement(_PopularDirectionOptions.PopularDirectionOptions, data);

    case 'allCountries':
      return /*#__PURE__*/_react["default"].createElement(_AllCountryOption.AllCountryOption, data);

    case 'metaregions':
    case 'allMetaregions':
      {
        return /*#__PURE__*/_react["default"].createElement(_Template.Template, data, data.description);
      }

    case 'hotels':
      {
        return /*#__PURE__*/_react["default"].createElement(_Template.Template, data, data.cityName, data.countryName && /*#__PURE__*/_react["default"].createElement("span", null, ", ", data.countryName));
      }

    case 'regions':
      {
        var _data$activeRegions;

        return /*#__PURE__*/_react["default"].createElement(_Template.Template, data, (_data$activeRegions = data.activeRegions) !== null && _data$activeRegions !== void 0 ? _data$activeRegions : data.countryName);
      }

    default:
      return /*#__PURE__*/_react["default"].createElement(_Template.Template, data);
  }
};

exports.BodyOption = BodyOption;